import { LOCATION_INITIALIZED } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

@Injectable({
  providedIn: 'root'
})
export class TranslateHelperService {
  constructor() { }
}

// Those functions are used on project startup
export function ApplicationInitializerFactory(translate: TranslateService, injector: Injector) {
  return async () => {
    await injector.get(LOCATION_INITIALIZED, Promise.resolve(null));

    const deaultLang = 'pt';
    translate.addLangs(['en', 'pt']);
    translate.setDefaultLang(deaultLang);
    try {
      let language = await translate.getBrowserLang();
      await translate.use(language == "pt" ? language : "en").toPromise();
    } catch (err) {
      console.error(err);
    }
  };
}

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}